import React from 'react';
import { Trans } from '@lt/localization';

import LinkPopup from 'src/components/Popup/LinkPopup';

import styled from 'styled-components';
import { VISA_TYPES } from '../../../../routes/Checkout/store/domains/visa';

import type { PropsFromRedux } from '.';

export const VisaInfoWarning = (props: PropsFromRedux): JSX.Element | null => {
  const { visaType, warningText, rulesLink, countryTo, isMobile } = props;

  if (!visaType || visaType === VISA_TYPES.NO_VISA) {
    return null;
  }
  return (
    <Container>
      <WarningText $isMobile={isMobile}>{warningText}</WarningText>

      {rulesLink && (
        <Info $isMobile={isMobile}>
          <Trans
            i18nKey="checkout.touristForm.visaRules"
            values={{ country: countryTo }}
            components={{
              Link: <Link href={rulesLink} />,
            }}
          />
        </Info>
      )}
    </Container>
  );
};

const Container = styled.div`
  margin-bottom: 20px;
  padding: 5px 25px;
  background-color: #f9eaec;
  border-radius: 4px;
`;

const WarningText = styled.div<{ $isMobile: boolean }>`
  font-size: ${({ $isMobile }) => ($isMobile ? 13 : 14)}px;
  font-weight: 500;
  color: #17181a;
`;

const Info = styled.div<{ $isMobile: boolean }>`
  font-size: ${({ $isMobile }) => ($isMobile ? 11 : 12)}px;
  color: #918284;
`;

const Link = styled(LinkPopup)`
  text-decoration: none;
  color: #007aff;
`;
